import React from 'react';
import numbro from 'numbro';
import { VIP_FEEDBACK_RATE, SPECS, isMobile } from '../../constants';
import PanelLoading from '../../components/panelLoading';

class ChoosePaymentMethodAndSpec extends React.Component {
    constructor(props) {
        super(props);
        this.nextStep = this.nextStep.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    onChange(name, value) {
        this.props.updateData({ [name]: value });
    }
    nextStep() {
        this.props.jumpToStep(1);
    }
    render() {
        const { paymentMethods } = this.props;
        const { paymentMethod, spec } = this.props.data;
        const { vipCardLevel, vipStatus, loading } = this.props.userInfo;
        const feedbackRate = vipStatus ? VIP_FEEDBACK_RATE[vipCardLevel] : 0;
        let newPaymentMethods = paymentMethods;
        if(isMobile) {
            newPaymentMethods = paymentMethods.filter(entry=>!entry.code.endsWith('_webatm'))
        }

        return (
            <div className="panel panel-default" style={{ marginTop: '30px' }}>
                <div className="panel-heading">Step1. 選擇付款方式與金額</div>
                <div className="panel-body" style={{ position: 'relative' }}>
                    {loading && <PanelLoading />}
                    {vipStatus === 0 && <PanelLoading loading={false} />}
                    <p>選擇付款方式</p>
                    <div className="btn-group btn-group-justified">
                        {
                            newPaymentMethods.map(entry => (
                                <div key={entry.id} className="btn-group">
                                    <button
                                        className={entry.id === paymentMethod ? 'btn btn-pubgame' : 'btn btn-default'}
                                        onClick={() => this.onChange('paymentMethod', entry.id)} >
                                        {entry.name}
                                    </button>
                                </div>
                            ))
                        }
                    </div>
                    <hr />
                    <p>選擇金額</p>
                    <div className="list-group">
                        {
                            SPECS.map(entry => (
                                <button key={entry.id}
                                    type="button"
                                    className={entry.id === spec ? 'btn btn-block btn-pubgame' : 'btn btn-block btn-default'}
                                    onClick={() => this.onChange('spec', entry.id)}>
                                    <div>
                                        <div className="text-center col-md-offset-1 col-md-3 col-sm-4 col-xs-12">
                                            {numbro(entry.price).format('0,0')}元
                                        </div>
                                        <div className="text-center col-md-3 col-sm-4 col-xs-12">
                                            兌換 {numbro(entry.price).format('0,0')} Pub點
                                        </div>
                                        <div className="text-center col-md-4 col-sm-4 col-xs-12">
                                            回饋 {numbro(entry.price * feedbackRate).format('0,0')} Pub點
                                        </div>
                                    </div>
                                </button>
                            ))
                        }
                    </div>
                    <hr />
                    <button className="btn btn-pubgame" style={{ float: 'right' }} onClick={this.nextStep}>下一步</button>
                </div>
            </div>
        );
    }
}

export default ChoosePaymentMethodAndSpec;


// WEBPACK FOOTER //
// ./src/containers/shop/choosePaymentMethodAndSpec.jsx